import { colors, typography } from '@mehilainen/mds-tokens';
import { focusVisible } from './shared';
/*
 * Note: _tokens are provided for future reference
 * Rename to tokens if used
 */
export const getThemePagination = (_tokens) => ({
    MuiPagination: {
        defaultProps: {
            shape: 'rounded',
            variant: 'outlined',
            size: 'large',
        },
    },
    MuiPaginationItem: {
        defaultProps: {},
        styleOverrides: {
            outlined: ({ ownerState }) => (Object.assign(Object.assign({}, typography.textStyle300MediumHeightL), { color: colors.Primary500, margin: '0 4px', 
                // Ellipsis is also a paginationitem
                ':not([class*="MuiPaginationItem-ellipsis"])': ownerState.selected
                    ? {
                        border: 'unset',
                        backgroundColor: colors.Primary500,
                        color: colors.White,
                        '&:hover': {
                            backgroundColor: colors.Success400,
                        },
                        // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                        '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { backgroundColor: colors.Success400, outlineOffset: '2px' }),
                    }
                    : {
                        border: '2px solid',
                        borderColor: colors.Gray300,
                        backgroundColor: colors.White,
                        '&:hover': {
                            borderWidth: '2px',
                            backgroundColor: colors.White,
                            borderColor: colors.Primary500,
                        },
                        // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                        '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '2px' }),
                    }, '&[class*="MuiPaginationItem-ellipsis"]': {
                    minWidth: 'unset',
                    padding: ownerState.size === 'large'
                        ? '5px 5px 7px'
                        : ownerState.size === 'medium'
                            ? '4px 4px 6px'
                            : '3px 3px 5px',
                    fontWeight: 900,
                    color: colors.Gray500,
                } })),
        },
    },
    // NOTE: TablePagination is written to ./table.ts
});
